import React from 'react';
import { observer } from 'mobx-react';
import CurrentUserStore from 'stores/CurrentUserStore';
import UserStore from 'stores/UserStore';
import { Form, Input, Button, Select } from 'antd';
import {
  UserOutlined,
  PhoneOutlined,
  LockOutlined,
  ShopOutlined,
} from '@ant-design/icons';

const EditProfilePage = observer(() => {
  const [form] = Form.useForm();

  const updateUser = async () => {
    try {
      const values = await form.validateFields();
      await UserStore.updateUser(CurrentUserStore.user.id, {
        firstName: values.firstName.trim(),
        lastName: values.lastName.trim(),
        phone: values.phone.trim(),
        default_shop_id: values.default_shop_id,
      });
      CurrentUserStore.getCurrentUser();
    } catch (error) {
      console.error('Validation Failed:', error);
    }
  };

  const shopOptions =
    CurrentUserStore.user?.shop?.map((shop) => ({
      label: shop.name,
      value: shop.id,
    })) || [];

  return (
    <Form
      form={form}
      onFinish={updateUser}
      layout="vertical"
      initialValues={{
        firstName: CurrentUserStore.user.firstName,
        lastName: CurrentUserStore.user.lastName,
        phone: CurrentUserStore.user.phone,
        email: CurrentUserStore.user.email,
        role: CurrentUserStore.user.displayedRole,
        default_shop_id: CurrentUserStore.user.defaultShopId,
      }}
    >
      <Form.Item
        label="First Name"
        name="firstName"
        rules={[{ required: true, message: 'Please input your first name!' }]}
      >
        <Input prefix={<UserOutlined />} placeholder="First Name" />
      </Form.Item>

      <Form.Item
        label="Last Name"
        name="lastName"
        rules={[{ required: true, message: 'Please input your last name!' }]}
      >
        <Input prefix={<UserOutlined />} placeholder="Last Name" />
      </Form.Item>

      <Form.Item
        label="Phone Number"
        name="phone"
        rules={[{ message: 'Please input your phone number!' }]}
      >
        <Input prefix={<PhoneOutlined />} placeholder="Phone" />
      </Form.Item>

      <Form.Item
        label="Email"
        name="email"
        rules={[{ required: true, message: 'Please input your email!' }]}
      >
        <Input prefix={<LockOutlined />} disabled />
      </Form.Item>

      <Form.Item
        label="Role"
        name="role"
        rules={[
          {
            required: true,
            disabled: true,
            message: 'Please input your role!',
          },
        ]}
      >
        <Input prefix={<LockOutlined />} disabled />
      </Form.Item>

      <Form.Item label="Default Shop" name="default_shop_id">
        <Select
          showSearch
          allowClear
          placeholder="Select a shop"
          optionFilterProp="label"
          options={shopOptions}
          prefix={<ShopOutlined />}
        />
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit" className="login-form-button">
          Update Info
        </Button>
      </Form.Item>
    </Form>
  );
});

export default EditProfilePage;
